import React from 'react';
import { useSelector } from 'react-redux';
import { path } from 'ramda';
import Typography from '@material-ui/core/Typography';
import { Grid, Avatar } from '@material-ui/core';
import { withRouter } from 'react-router-dom';

const getAvatarLetter = (name) => {
  try {
    return name[0].toUpperCase()
  } catch (error) {
    return '';
  }
}

function AccountSwitcher({ history, handleDrawerClose }) {
  const name = useSelector(path(['user', 'current', 'data', 'firstName']));

  return (
    <React.Fragment>
      <div style={{ padding: '8px 16px', lineHeight: '1.4rem', cursor: 'pointer' }} onClick={handleDrawerClose}>
        <Grid
          container
          wrap='nowrap'
          spacing={1}
          alignItems='center'
          onClick={() => history.push('/profile')}
        >
          <Grid item>
            <Avatar color='primary'>
              {getAvatarLetter(name)}
            </Avatar>
          </Grid>
          <Grid item container>
            <Grid item xs={12}>
              <Typography variant='subtitle1' color='textPrimary' style={{ lineHeight: '1.4rem' }}>
                {name}
                {' '}
                {useSelector(path(['user', 'current', 'data', 'lastName']))}
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ lineHeight: '1.4rem' }}>
              <Typography variant='caption' color='textSecondary'>
                {useSelector(path(['user', 'current', 'data', 'company', 'name']))}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </React.Fragment>
  )
}

export default withRouter(AccountSwitcher);